export default __webpack_public_path__ + "images/d3f59f66da2ce27d4137206d8889d3a9.png";